<template>
    <div>
        <p class="fc-theme marginT-10 marginB-10">TOP20万关键词列表</p>
        <div class="top-select">
            <div class="flex align-center">
                <span>关键词日期：</span>
                <el-select v-model="selectPubdate" @change="dataChange">
                    <el-option v-for="(item, index) in allDate" :key="index" :label="item.pubdate" :value="item.pubdate"></el-option>
                </el-select>
            </div>
            <!-- <el-button type="primary" @click="cascaderOption = []">更改</el-button> -->
            <el-cascader-panel v-if="selectPubdate" class="marginT-20" ref="cascader" v-model="cascader" :options="cascaderOption" :props="cascaderProp" @expand-change="expandChange" @change="casChange"></el-cascader-panel>
        </div>

        <div class="query-record">
            <el-card class="box-card flex-1 marginT-20">
                <div slot="header" class="flex flex-between">
                    <div class="flex">
                        <el-input v-model="searchKey" size="mini" placeholder="请输入关键词"></el-input>
                        <el-button class="marginL-10" type="primary" size="mini" @click="searchSubmit">搜索</el-button>
                    </div>
                    <!-- <el-button></el-button> -->
                    <!-- <span class="fw-bold fc-333">打标查询记录<span style="font-size: 12px; color: #f00; padding-left: 6px;">(查询记录数据仅保存90天)</span></span> -->
                    <!-- <span class="fc-theme fs-14">1分钟后自动刷新更新</span> -->
                </div>
                <div>
                    <div class="table">
                        <el-table :data="tableData" border>
                            <el-table-column prop="keyword" label="关键词"></el-table-column>
                            <el-table-column prop="type" label="PC端Top20万词表">
                                <template slot-scope="scope">
                                    <i v-if="scope.row.type.indexOf('1') > -1" class="el-icon-check fw-bold fc-down"></i>
                                    <i v-else class="el-icon-close fw-bold fc-up"></i>
                                </template>
                            </el-table-column>
                            <el-table-column prop="type" label="无线端Top20万词表">
                                <template slot-scope="scope">
                                    <i v-if="scope.row.type.indexOf('2') > -1" class="el-icon-check fw-bold fc-down"></i>
                                    <i v-else class="el-icon-close fw-bold fc-up"></i>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pages marginT-20 text-center">
                        <el-pagination @current-change="handleCurrentChange"
                            @size-change="handleSizeChange"
                            :current-page="page" :page-sizes="[10, 20, 50, 100, 500]" :page-size="psize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
let id = 0
export default {
    data() {
        return {
            allDate: [],
            psize: 10,
            searchKey: '',
            cascader: undefined,
            cascaderOption: [],
            selectPubdate: '',
            allTableData: [],
            table: [],
            tableData: [],
            page: 1,
            total: 0,
            cascaderProp: {
                lazy: true,
                value: 'id',
                label: 'name',
                lazyLoad: this.lazyLoad
            }
        }
    },
    methods: {
        dataChange() {
            this.cascaderOption = []
        },
        casChange(val) {
            this.getAlltable(val[val.length - 1])
        },
        expandChange(arr) {
            this.getAlltable(arr[arr.length - 1])
        },
        async lazyLoad(node, resolve) {
            console.log(node)
            let parent_id = node.root ? 0 : node.value
            const data = await this.$fetch('/tool/accounts/tao-top20w', {parent_id, pubdate: this.selectPubdate}, 'post')

            if (data.code == 0) {
                resolve(data.data.list.map(item => {
                    return {
                        ...item,
                        name: `${item.name}(${item.keyword_num})`,
                        // name: `${item.name}(0)`,
                        leaf: item.childs == 0
                    }
                }))
            }
        },
        handleCurrentChange(page) {
            this.page = page
            this.tableData = this.table.slice((page - 1) * this.psize, page * this.psize)
            // this.init()
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`)
            this.page = 1
            this.handleCurrentChange(1)
        },
        async getAlltable(cat_id) {
            window.checkDiscountPackage("taosuggest")
            const data = await this.$fetch('/api/proxy/web/tao20w', {cat_id}, 'post')
            if (data.code == 0) {
                let tableObject = {}
                data.data.list.forEach(item => {
                    if (tableObject[item.keyword]) {
                        tableObject[item.keyword].type = tableObject[item.keyword].type + item.type
                    } else {
                        tableObject[item.keyword] = {...item, type: item.type + ''}
                    }
                })
                let tableList = Object.values(tableObject)
                this.allTableData = [...tableList]
                this.table = tableList
                this.total = tableList.length
                this.tableData = this.table.slice(0, 10)
            }
        },
        async getAllDate() {
            const data = await this.$fetch('/tool/accounts/tao-top20w-pubdate', {}, 'post')
            if (data.code == 0) {
                this.allDate = data.data.list
                this.selectPubdate = data.data.list[0].pubdate
            }
        },
        searchSubmit() {
            if (!this.searchKey.replace(/ /g,'')) {
                this.table = [...this.allTableData]
                this.tableData = this.table.slice(0, 10)
                this.total = this.table.length
                return
            }

            this.table = this.allTableData.filter(x => x.keyword.indexOf(this.searchKey.replace(/ /g,'')) > -1)
            this.tableData = this.table.slice(0, 10)
            this.page = 1
            this.total = this.table.length
        }
    },
    mounted () {
        this.getAllDate()
    },
}
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
.lexicon .top-select .el-cascader-menu__wrap {
    height: 300px;
}
</style>
